// Hands an event typed into the home search bar to the create page. Kept in
// sessionStorage so it survives signing in on the way; this tab only.
const KEY = 'frolik_event_draft';

export function saveEventDraft(draft) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(draft));
  } catch (error) {
    // Storage blocked: the create page just opens empty.
  }
}

export function readEventDraft() {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
}

export function clearEventDraft() {
  try {
    sessionStorage.removeItem(KEY);
  } catch (error) {
    // Nothing to clear.
  }
}
